import './App.css';
import LandingPage from "./components/landingPage";
import ReactGA from 'react-ga';
// import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
    ReactGA.initialize('G-XP49JBJFFH');
    ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div className="App">
      <LandingPage/>
    </div>
  );
}

export default App;
